const updates = [
  { id: 1, date: '07-30', title: '暗夜追凶大结局今晚在妖精视频首播，嫩草视频同步更新完整版', tag: '热剧更新' },
  { id: 2, date: '07-29', title: '桃花视频暑期档片单新增 5 部独播剧，嫩草视频已同步收录', tag: '平台动态' },
  { id: 3, date: '07-28', title: '苹果视频重磅上线长安秘事录，首日播放量突破 5000 万', tag: '新剧上线' },
  { id: 4, date: '07-27', title: '嫩草视频移动端适配优化完成，手机追剧体验全面升级', tag: '功能更新' },
  { id: 5, date: '07-26', title: '榴莲视频科幻巨制星辰大海定档 8 月，嫩草视频已开启预约通道', tag: '即将上线' },
  { id: 6, date: '07-25', title: '豆花视频宣布与桃花园影业达成战略合作，多部新剧即将上线', tag: '行业动态' },
  { id: 7, date: '07-24', title: '嫩草视频影视分类功能升级，新增悬疑、古装等精细分类索引', tag: '功能更新' },
  { id: 8, date: '07-23', title: '山海异兽录播放量破 10 亿，妖精视频、桃花视频双平台联播创纪录', tag: '热剧数据' },
  { id: 9, date: '07-22', title: '暑期热播剧追剧日历更新，嫩草视频整理完整版排播时间表', tag: '追剧指南' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-timer-flash-line"></i>
            实时快讯
          </div>
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            追踪妖精视频、桃花视频等平台的影视更新和行业动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item) => (
            <div key={item.id} className="flex items-start gap-3 md:gap-4 py-4 border-b border-background-200/70 last:border-b-0 group cursor-pointer hover:bg-background-50 rounded-lg px-3 transition-colors">
              <div className="text-foreground-500 text-xs md:text-sm font-medium whitespace-nowrap pt-0.5 flex-shrink-0">
                {item.date}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-foreground-800 text-sm leading-relaxed group-hover:text-primary-500 transition-colors">
                  {item.title}
                </p>
              </div>
              <span className="px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-[10px] font-medium whitespace-nowrap flex-shrink-0">
                {item.tag}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}